import { AxiosInstance } from 'axios'
import { deserialize } from 'ts-jackson'
import { wrapApiCall } from '@/lib/axios'
import {
  Bank,
  CreatePaymentBody,
  CreditExchange,
  CreditQuote,
  creditQuoteParam,
  CreditTransaction,
  PurchaseCredit,
  TransferCreditBody,
} from './model'
import { PageInfo, PaginationOpt, PaginationResponse } from '../model'

export const CreditService = (client: AxiosInstance) => {
  return {
    async getCreditQuote(params: creditQuoteParam): Promise<CreditQuote> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>>('/credits/quote', { params: params })
      )
      return deserialize(data, CreditQuote)
    },
    async getCreditExchange(): Promise<CreditExchange[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>('/credits/exchange-rates')
      )
      return data?.map((item: Record<string, unknown>) => deserialize(item, CreditExchange))
    },
    async getBanks(): Promise<Bank[]> {
      const { data } = await wrapApiCall(() => client.get<Record<string, unknown>[]>('/banks'))
      return data?.map((item: Record<string, unknown>) => deserialize(item, Bank))
    },
    async purchaseCredit(createData: CreatePaymentBody): Promise<PurchaseCredit> {
      const { data } = await wrapApiCall(() =>
        client.post<Record<string, unknown>>(`/credits/purchase`, createData)
      )
      return deserialize(data, PurchaseCredit)
    },
    async transferCredit(body: TransferCreditBody): Promise<void> {
      await wrapApiCall(() => client.post('/credits/transfer', body))
    },
    async getCreditTransaction(
      opt: PaginationOpt & { yearMonth?: string; memberId?: string }
    ): Promise<PaginationResponse<CreditTransaction>> {
      const params = {
        page: opt.page,
        pageSize: opt.pageSize,
        month: opt.yearMonth,
        query: opt.query,
        userId: opt.memberId,
      }
      const { data } = await wrapApiCall(() =>
        client.get<{ pagination: Record<string, unknown>; data: Record<string, unknown>[] }>(
          '/credits/transactions',
          { params }
        )
      )
      return {
        pagination: deserialize(data?.pagination, PageInfo),
        data: data?.data?.map((item: Record<string, unknown>) =>
          deserialize(item, CreditTransaction)
        ),
      }
    },
  }
}
